/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * train-with-me
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetWorkoutExecutionActiveParams,
  GetWorkoutExecutionIdDisplayParams,
  GetWorkoutExecutionIdParams,
  MicrosoftAspNetCoreMvcProblemDetails,
  PatchWorkoutExecutionIdParams,
  PostWorkoutExecutionAdHocParams,
  PostWorkoutExecutionIdCompleteParams,
  PostWorkoutExecutionIdStartParams,
  PostWorkoutExecutionStartNextFromPlanParams,
  TrainWithMeModulesTrainingDtosRequestsPatchExerciseClientNoteRequest,
  TrainWithMeModulesTrainingDtosRequestsPatchExerciseTrainerNoteRequest,
  TrainWithMeModulesTrainingDtosRequestsPatchWorkoutExecutionRequest,
  TrainWithMeModulesTrainingDtosRequestsPostAdHocRequest,
  TrainWithMeModulesTrainingDtosRequestsPostCompleteRequest,
  TrainWithMeModulesTrainingDtosRequestsPostSkipNextFromPlanRequest,
  TrainWithMeModulesTrainingDtosRequestsPostStartNextFromPlanRequest,
  TrainWithMeModulesTrainingDtosResponsesExerciseClientNoteResponse,
  TrainWithMeModulesTrainingDtosResponsesExerciseLastExecutionResponse,
  TrainWithMeModulesTrainingDtosResponsesExerciseTrainerNoteResponse,
  TrainWithMeModulesTrainingDtosResponsesNextFromPlanResponse,
  TrainWithMeModulesTrainingDtosResponsesSkipOccurrenceResponse,
  TrainWithMeModulesTrainingDtosResponsesWorkoutExecutionDisplayResponse,
  TrainWithMeModulesTrainingDtosResponsesWorkoutExecutionFullResponse
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getWorkoutExecutionActive = (
    params?: GetWorkoutExecutionActiveParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesWorkoutExecutionFullResponse>(
      {url: `/workout-execution/active`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetWorkoutExecutionActiveQueryKey = (params?: GetWorkoutExecutionActiveParams,) => {
    return [
    `/workout-execution/active`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetWorkoutExecutionActiveQueryOptions = <TData = Awaited<ReturnType<typeof getWorkoutExecutionActive>>, TError = ErrorType<unknown>>(params?: GetWorkoutExecutionActiveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkoutExecutionActive>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkoutExecutionActiveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkoutExecutionActive>>> = ({ signal }) => getWorkoutExecutionActive(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkoutExecutionActive>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkoutExecutionActiveQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkoutExecutionActive>>>
export type GetWorkoutExecutionActiveQueryError = ErrorType<unknown>


export function useGetWorkoutExecutionActive<TData = Awaited<ReturnType<typeof getWorkoutExecutionActive>>, TError = ErrorType<unknown>>(
 params: undefined |  GetWorkoutExecutionActiveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkoutExecutionActive>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkoutExecutionActive>>,
          TError,
          Awaited<ReturnType<typeof getWorkoutExecutionActive>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkoutExecutionActive<TData = Awaited<ReturnType<typeof getWorkoutExecutionActive>>, TError = ErrorType<unknown>>(
 params?: GetWorkoutExecutionActiveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkoutExecutionActive>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkoutExecutionActive>>,
          TError,
          Awaited<ReturnType<typeof getWorkoutExecutionActive>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkoutExecutionActive<TData = Awaited<ReturnType<typeof getWorkoutExecutionActive>>, TError = ErrorType<unknown>>(
 params?: GetWorkoutExecutionActiveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkoutExecutionActive>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetWorkoutExecutionActive<TData = Awaited<ReturnType<typeof getWorkoutExecutionActive>>, TError = ErrorType<unknown>>(
 params?: GetWorkoutExecutionActiveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkoutExecutionActive>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkoutExecutionActiveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postWorkoutExecutionAdHoc = (
    trainWithMeModulesTrainingDtosRequestsPostAdHocRequest?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostAdHocRequest>,
    params?: PostWorkoutExecutionAdHocParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesWorkoutExecutionFullResponse>(
      {url: `/workout-execution/ad-hoc`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesTrainingDtosRequestsPostAdHocRequest,
        params, signal
    },
      options);
    }




export const getPostWorkoutExecutionAdHocMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWorkoutExecutionAdHoc>>, TError,{data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostAdHocRequest>;params?: PostWorkoutExecutionAdHocParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postWorkoutExecutionAdHoc>>, TError,{data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostAdHocRequest>;params?: PostWorkoutExecutionAdHocParams}, TContext> => {

const mutationKey = ['postWorkoutExecutionAdHoc'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postWorkoutExecutionAdHoc>>, {data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostAdHocRequest>;params?: PostWorkoutExecutionAdHocParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postWorkoutExecutionAdHoc(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostWorkoutExecutionAdHocMutationResult = NonNullable<Awaited<ReturnType<typeof postWorkoutExecutionAdHoc>>>
    export type PostWorkoutExecutionAdHocMutationBody = BodyType<TrainWithMeModulesTrainingDtosRequestsPostAdHocRequest> | undefined
    export type PostWorkoutExecutionAdHocMutationError = ErrorType<unknown>

    export const usePostWorkoutExecutionAdHoc = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWorkoutExecutionAdHoc>>, TError,{data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostAdHocRequest>;params?: PostWorkoutExecutionAdHocParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postWorkoutExecutionAdHoc>>,
        TError,
        {data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostAdHocRequest>;params?: PostWorkoutExecutionAdHocParams},
        TContext
      > => {
      return useMutation(getPostWorkoutExecutionAdHocMutationOptions(options), queryClient);
    }
    export const getWorkoutExecutionNextFromPlanCustomerId = (
    customerId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesNextFromPlanResponse>(
      {url: `/workout-execution/next-from-plan/${customerId}`, method: 'GET', signal
    },
      options);
    }




export const getGetWorkoutExecutionNextFromPlanCustomerIdQueryKey = (customerId: number,) => {
    return [
    `/workout-execution/next-from-plan/${customerId}`
    ] as const;
    }


export const getGetWorkoutExecutionNextFromPlanCustomerIdQueryOptions = <TData = Awaited<ReturnType<typeof getWorkoutExecutionNextFromPlanCustomerId>>, TError = ErrorType<unknown>>(customerId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkoutExecutionNextFromPlanCustomerId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkoutExecutionNextFromPlanCustomerIdQueryKey(customerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkoutExecutionNextFromPlanCustomerId>>> = ({ signal }) => getWorkoutExecutionNextFromPlanCustomerId(customerId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: customerId !== null && customerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkoutExecutionNextFromPlanCustomerId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkoutExecutionNextFromPlanCustomerIdQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkoutExecutionNextFromPlanCustomerId>>>
export type GetWorkoutExecutionNextFromPlanCustomerIdQueryError = ErrorType<unknown>


export function useGetWorkoutExecutionNextFromPlanCustomerId<TData = Awaited<ReturnType<typeof getWorkoutExecutionNextFromPlanCustomerId>>, TError = ErrorType<unknown>>(
 customerId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkoutExecutionNextFromPlanCustomerId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkoutExecutionNextFromPlanCustomerId>>,
          TError,
          Awaited<ReturnType<typeof getWorkoutExecutionNextFromPlanCustomerId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkoutExecutionNextFromPlanCustomerId<TData = Awaited<ReturnType<typeof getWorkoutExecutionNextFromPlanCustomerId>>, TError = ErrorType<unknown>>(
 customerId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkoutExecutionNextFromPlanCustomerId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkoutExecutionNextFromPlanCustomerId>>,
          TError,
          Awaited<ReturnType<typeof getWorkoutExecutionNextFromPlanCustomerId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkoutExecutionNextFromPlanCustomerId<TData = Awaited<ReturnType<typeof getWorkoutExecutionNextFromPlanCustomerId>>, TError = ErrorType<unknown>>(
 customerId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkoutExecutionNextFromPlanCustomerId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetWorkoutExecutionNextFromPlanCustomerId<TData = Awaited<ReturnType<typeof getWorkoutExecutionNextFromPlanCustomerId>>, TError = ErrorType<unknown>>(
 customerId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkoutExecutionNextFromPlanCustomerId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkoutExecutionNextFromPlanCustomerIdQueryOptions(customerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postWorkoutExecutionSkipNextFromPlan = (
    trainWithMeModulesTrainingDtosRequestsPostSkipNextFromPlanRequest?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostSkipNextFromPlanRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesSkipOccurrenceResponse>(
      {url: `/workout-execution/skip-next-from-plan`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesTrainingDtosRequestsPostSkipNextFromPlanRequest, signal
    },
      options);
    }




export const getPostWorkoutExecutionSkipNextFromPlanMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWorkoutExecutionSkipNextFromPlan>>, TError,{data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostSkipNextFromPlanRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postWorkoutExecutionSkipNextFromPlan>>, TError,{data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostSkipNextFromPlanRequest>}, TContext> => {

const mutationKey = ['postWorkoutExecutionSkipNextFromPlan'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postWorkoutExecutionSkipNextFromPlan>>, {data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostSkipNextFromPlanRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postWorkoutExecutionSkipNextFromPlan(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostWorkoutExecutionSkipNextFromPlanMutationResult = NonNullable<Awaited<ReturnType<typeof postWorkoutExecutionSkipNextFromPlan>>>
    export type PostWorkoutExecutionSkipNextFromPlanMutationBody = BodyType<TrainWithMeModulesTrainingDtosRequestsPostSkipNextFromPlanRequest> | undefined
    export type PostWorkoutExecutionSkipNextFromPlanMutationError = ErrorType<unknown>

    export const usePostWorkoutExecutionSkipNextFromPlan = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWorkoutExecutionSkipNextFromPlan>>, TError,{data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostSkipNextFromPlanRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postWorkoutExecutionSkipNextFromPlan>>,
        TError,
        {data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostSkipNextFromPlanRequest>},
        TContext
      > => {
      return useMutation(getPostWorkoutExecutionSkipNextFromPlanMutationOptions(options), queryClient);
    }
    export const postWorkoutExecutionStartNextFromPlan = (
    trainWithMeModulesTrainingDtosRequestsPostStartNextFromPlanRequest?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostStartNextFromPlanRequest>,
    params?: PostWorkoutExecutionStartNextFromPlanParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesWorkoutExecutionFullResponse>(
      {url: `/workout-execution/start-next-from-plan`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesTrainingDtosRequestsPostStartNextFromPlanRequest,
        params, signal
    },
      options);
    }




export const getPostWorkoutExecutionStartNextFromPlanMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWorkoutExecutionStartNextFromPlan>>, TError,{data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostStartNextFromPlanRequest>;params?: PostWorkoutExecutionStartNextFromPlanParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postWorkoutExecutionStartNextFromPlan>>, TError,{data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostStartNextFromPlanRequest>;params?: PostWorkoutExecutionStartNextFromPlanParams}, TContext> => {

const mutationKey = ['postWorkoutExecutionStartNextFromPlan'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postWorkoutExecutionStartNextFromPlan>>, {data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostStartNextFromPlanRequest>;params?: PostWorkoutExecutionStartNextFromPlanParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postWorkoutExecutionStartNextFromPlan(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostWorkoutExecutionStartNextFromPlanMutationResult = NonNullable<Awaited<ReturnType<typeof postWorkoutExecutionStartNextFromPlan>>>
    export type PostWorkoutExecutionStartNextFromPlanMutationBody = BodyType<TrainWithMeModulesTrainingDtosRequestsPostStartNextFromPlanRequest> | undefined
    export type PostWorkoutExecutionStartNextFromPlanMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostWorkoutExecutionStartNextFromPlan = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWorkoutExecutionStartNextFromPlan>>, TError,{data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostStartNextFromPlanRequest>;params?: PostWorkoutExecutionStartNextFromPlanParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postWorkoutExecutionStartNextFromPlan>>,
        TError,
        {data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostStartNextFromPlanRequest>;params?: PostWorkoutExecutionStartNextFromPlanParams},
        TContext
      > => {
      return useMutation(getPostWorkoutExecutionStartNextFromPlanMutationOptions(options), queryClient);
    }
    export const getWorkoutExecutionId = (
    id: number,
    params?: GetWorkoutExecutionIdParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesWorkoutExecutionFullResponse>(
      {url: `/workout-execution/${id}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetWorkoutExecutionIdQueryKey = (id: number,
    params?: GetWorkoutExecutionIdParams,) => {
    return [
    `/workout-execution/${id}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetWorkoutExecutionIdQueryOptions = <TData = Awaited<ReturnType<typeof getWorkoutExecutionId>>, TError = ErrorType<unknown>>(id: number,
    params?: GetWorkoutExecutionIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkoutExecutionId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkoutExecutionIdQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkoutExecutionId>>> = ({ signal }) => getWorkoutExecutionId(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkoutExecutionId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkoutExecutionIdQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkoutExecutionId>>>
export type GetWorkoutExecutionIdQueryError = ErrorType<unknown>


export function useGetWorkoutExecutionId<TData = Awaited<ReturnType<typeof getWorkoutExecutionId>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  GetWorkoutExecutionIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkoutExecutionId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkoutExecutionId>>,
          TError,
          Awaited<ReturnType<typeof getWorkoutExecutionId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkoutExecutionId<TData = Awaited<ReturnType<typeof getWorkoutExecutionId>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetWorkoutExecutionIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkoutExecutionId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkoutExecutionId>>,
          TError,
          Awaited<ReturnType<typeof getWorkoutExecutionId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkoutExecutionId<TData = Awaited<ReturnType<typeof getWorkoutExecutionId>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetWorkoutExecutionIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkoutExecutionId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetWorkoutExecutionId<TData = Awaited<ReturnType<typeof getWorkoutExecutionId>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetWorkoutExecutionIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkoutExecutionId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkoutExecutionIdQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchWorkoutExecutionId = (
    id: number,
    trainWithMeModulesTrainingDtosRequestsPatchWorkoutExecutionRequest?: BodyType<TrainWithMeModulesTrainingDtosRequestsPatchWorkoutExecutionRequest>,
    params?: PatchWorkoutExecutionIdParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesWorkoutExecutionFullResponse>(
      {url: `/workout-execution/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesTrainingDtosRequestsPatchWorkoutExecutionRequest,
        params, signal
    },
      options);
    }




export const getPatchWorkoutExecutionIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchWorkoutExecutionId>>, TError,{id: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPatchWorkoutExecutionRequest>;params?: PatchWorkoutExecutionIdParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchWorkoutExecutionId>>, TError,{id: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPatchWorkoutExecutionRequest>;params?: PatchWorkoutExecutionIdParams}, TContext> => {

const mutationKey = ['patchWorkoutExecutionId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchWorkoutExecutionId>>, {id: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPatchWorkoutExecutionRequest>;params?: PatchWorkoutExecutionIdParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  patchWorkoutExecutionId(id,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchWorkoutExecutionIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchWorkoutExecutionId>>>
    export type PatchWorkoutExecutionIdMutationBody = BodyType<TrainWithMeModulesTrainingDtosRequestsPatchWorkoutExecutionRequest> | undefined
    export type PatchWorkoutExecutionIdMutationError = ErrorType<unknown>

    export const usePatchWorkoutExecutionId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchWorkoutExecutionId>>, TError,{id: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPatchWorkoutExecutionRequest>;params?: PatchWorkoutExecutionIdParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchWorkoutExecutionId>>,
        TError,
        {id: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPatchWorkoutExecutionRequest>;params?: PatchWorkoutExecutionIdParams},
        TContext
      > => {
      return useMutation(getPatchWorkoutExecutionIdMutationOptions(options), queryClient);
    }
    export const postWorkoutExecutionIdCancelStart = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/workout-execution/${id}/cancel-start`, method: 'POST', signal
    },
      options);
    }




export const getPostWorkoutExecutionIdCancelStartMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWorkoutExecutionIdCancelStart>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postWorkoutExecutionIdCancelStart>>, TError,{id: number}, TContext> => {

const mutationKey = ['postWorkoutExecutionIdCancelStart'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postWorkoutExecutionIdCancelStart>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  postWorkoutExecutionIdCancelStart(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostWorkoutExecutionIdCancelStartMutationResult = NonNullable<Awaited<ReturnType<typeof postWorkoutExecutionIdCancelStart>>>

    export type PostWorkoutExecutionIdCancelStartMutationError = ErrorType<unknown>

    export const usePostWorkoutExecutionIdCancelStart = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWorkoutExecutionIdCancelStart>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postWorkoutExecutionIdCancelStart>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getPostWorkoutExecutionIdCancelStartMutationOptions(options), queryClient);
    }
    export const postWorkoutExecutionIdComplete = (
    id: number,
    trainWithMeModulesTrainingDtosRequestsPostCompleteRequest?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostCompleteRequest>,
    params?: PostWorkoutExecutionIdCompleteParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesWorkoutExecutionFullResponse>(
      {url: `/workout-execution/${id}/complete`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesTrainingDtosRequestsPostCompleteRequest,
        params, signal
    },
      options);
    }




export const getPostWorkoutExecutionIdCompleteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWorkoutExecutionIdComplete>>, TError,{id: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostCompleteRequest>;params?: PostWorkoutExecutionIdCompleteParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postWorkoutExecutionIdComplete>>, TError,{id: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostCompleteRequest>;params?: PostWorkoutExecutionIdCompleteParams}, TContext> => {

const mutationKey = ['postWorkoutExecutionIdComplete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postWorkoutExecutionIdComplete>>, {id: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostCompleteRequest>;params?: PostWorkoutExecutionIdCompleteParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  postWorkoutExecutionIdComplete(id,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostWorkoutExecutionIdCompleteMutationResult = NonNullable<Awaited<ReturnType<typeof postWorkoutExecutionIdComplete>>>
    export type PostWorkoutExecutionIdCompleteMutationBody = BodyType<TrainWithMeModulesTrainingDtosRequestsPostCompleteRequest> | undefined
    export type PostWorkoutExecutionIdCompleteMutationError = ErrorType<unknown>

    export const usePostWorkoutExecutionIdComplete = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWorkoutExecutionIdComplete>>, TError,{id: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostCompleteRequest>;params?: PostWorkoutExecutionIdCompleteParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postWorkoutExecutionIdComplete>>,
        TError,
        {id: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPostCompleteRequest>;params?: PostWorkoutExecutionIdCompleteParams},
        TContext
      > => {
      return useMutation(getPostWorkoutExecutionIdCompleteMutationOptions(options), queryClient);
    }
    export const getWorkoutExecutionIdDisplay = (
    id: number,
    params?: GetWorkoutExecutionIdDisplayParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesWorkoutExecutionDisplayResponse>(
      {url: `/workout-execution/${id}/display`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetWorkoutExecutionIdDisplayQueryKey = (id: number,
    params?: GetWorkoutExecutionIdDisplayParams,) => {
    return [
    `/workout-execution/${id}/display`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetWorkoutExecutionIdDisplayQueryOptions = <TData = Awaited<ReturnType<typeof getWorkoutExecutionIdDisplay>>, TError = ErrorType<unknown>>(id: number,
    params?: GetWorkoutExecutionIdDisplayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkoutExecutionIdDisplay>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkoutExecutionIdDisplayQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkoutExecutionIdDisplay>>> = ({ signal }) => getWorkoutExecutionIdDisplay(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkoutExecutionIdDisplay>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkoutExecutionIdDisplayQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkoutExecutionIdDisplay>>>
export type GetWorkoutExecutionIdDisplayQueryError = ErrorType<unknown>


export function useGetWorkoutExecutionIdDisplay<TData = Awaited<ReturnType<typeof getWorkoutExecutionIdDisplay>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  GetWorkoutExecutionIdDisplayParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkoutExecutionIdDisplay>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkoutExecutionIdDisplay>>,
          TError,
          Awaited<ReturnType<typeof getWorkoutExecutionIdDisplay>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkoutExecutionIdDisplay<TData = Awaited<ReturnType<typeof getWorkoutExecutionIdDisplay>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetWorkoutExecutionIdDisplayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkoutExecutionIdDisplay>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkoutExecutionIdDisplay>>,
          TError,
          Awaited<ReturnType<typeof getWorkoutExecutionIdDisplay>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkoutExecutionIdDisplay<TData = Awaited<ReturnType<typeof getWorkoutExecutionIdDisplay>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetWorkoutExecutionIdDisplayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkoutExecutionIdDisplay>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetWorkoutExecutionIdDisplay<TData = Awaited<ReturnType<typeof getWorkoutExecutionIdDisplay>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetWorkoutExecutionIdDisplayParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkoutExecutionIdDisplay>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkoutExecutionIdDisplayQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getWorkoutExecutionIdExerciseExerciseIdLastExecution = (
    id: number,
    exerciseId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesExerciseLastExecutionResponse>(
      {url: `/workout-execution/${id}/exercise/${exerciseId}/last-execution`, method: 'GET', signal
    },
      options);
    }




export const getGetWorkoutExecutionIdExerciseExerciseIdLastExecutionQueryKey = (id: number,
    exerciseId: number,) => {
    return [
    `/workout-execution/${id}/exercise/${exerciseId}/last-execution`
    ] as const;
    }


export const getGetWorkoutExecutionIdExerciseExerciseIdLastExecutionQueryOptions = <TData = Awaited<ReturnType<typeof getWorkoutExecutionIdExerciseExerciseIdLastExecution>>, TError = ErrorType<unknown>>(id: number,
    exerciseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkoutExecutionIdExerciseExerciseIdLastExecution>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkoutExecutionIdExerciseExerciseIdLastExecutionQueryKey(id,exerciseId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkoutExecutionIdExerciseExerciseIdLastExecution>>> = ({ signal }) => getWorkoutExecutionIdExerciseExerciseIdLastExecution(id,exerciseId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && exerciseId !== null && exerciseId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkoutExecutionIdExerciseExerciseIdLastExecution>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkoutExecutionIdExerciseExerciseIdLastExecutionQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkoutExecutionIdExerciseExerciseIdLastExecution>>>
export type GetWorkoutExecutionIdExerciseExerciseIdLastExecutionQueryError = ErrorType<unknown>


export function useGetWorkoutExecutionIdExerciseExerciseIdLastExecution<TData = Awaited<ReturnType<typeof getWorkoutExecutionIdExerciseExerciseIdLastExecution>>, TError = ErrorType<unknown>>(
 id: number,
    exerciseId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkoutExecutionIdExerciseExerciseIdLastExecution>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkoutExecutionIdExerciseExerciseIdLastExecution>>,
          TError,
          Awaited<ReturnType<typeof getWorkoutExecutionIdExerciseExerciseIdLastExecution>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkoutExecutionIdExerciseExerciseIdLastExecution<TData = Awaited<ReturnType<typeof getWorkoutExecutionIdExerciseExerciseIdLastExecution>>, TError = ErrorType<unknown>>(
 id: number,
    exerciseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkoutExecutionIdExerciseExerciseIdLastExecution>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkoutExecutionIdExerciseExerciseIdLastExecution>>,
          TError,
          Awaited<ReturnType<typeof getWorkoutExecutionIdExerciseExerciseIdLastExecution>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkoutExecutionIdExerciseExerciseIdLastExecution<TData = Awaited<ReturnType<typeof getWorkoutExecutionIdExerciseExerciseIdLastExecution>>, TError = ErrorType<unknown>>(
 id: number,
    exerciseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkoutExecutionIdExerciseExerciseIdLastExecution>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetWorkoutExecutionIdExerciseExerciseIdLastExecution<TData = Awaited<ReturnType<typeof getWorkoutExecutionIdExerciseExerciseIdLastExecution>>, TError = ErrorType<unknown>>(
 id: number,
    exerciseId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkoutExecutionIdExerciseExerciseIdLastExecution>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkoutExecutionIdExerciseExerciseIdLastExecutionQueryOptions(id,exerciseId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putWorkoutExecutionIdExercisesExerciseExecutionIdClientNote = (
    id: number,
    exerciseExecutionId: number,
    trainWithMeModulesTrainingDtosRequestsPatchExerciseClientNoteRequest?: BodyType<TrainWithMeModulesTrainingDtosRequestsPatchExerciseClientNoteRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesExerciseClientNoteResponse>(
      {url: `/workout-execution/${id}/exercises/${exerciseExecutionId}/client-note`, method: 'PUT',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesTrainingDtosRequestsPatchExerciseClientNoteRequest, signal
    },
      options);
    }




export const getPutWorkoutExecutionIdExercisesExerciseExecutionIdClientNoteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putWorkoutExecutionIdExercisesExerciseExecutionIdClientNote>>, TError,{id: number;exerciseExecutionId: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPatchExerciseClientNoteRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putWorkoutExecutionIdExercisesExerciseExecutionIdClientNote>>, TError,{id: number;exerciseExecutionId: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPatchExerciseClientNoteRequest>}, TContext> => {

const mutationKey = ['putWorkoutExecutionIdExercisesExerciseExecutionIdClientNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putWorkoutExecutionIdExercisesExerciseExecutionIdClientNote>>, {id: number;exerciseExecutionId: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPatchExerciseClientNoteRequest>}> = (props) => {
          const {id,exerciseExecutionId,data} = props ?? {};

          return  putWorkoutExecutionIdExercisesExerciseExecutionIdClientNote(id,exerciseExecutionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutWorkoutExecutionIdExercisesExerciseExecutionIdClientNoteMutationResult = NonNullable<Awaited<ReturnType<typeof putWorkoutExecutionIdExercisesExerciseExecutionIdClientNote>>>
    export type PutWorkoutExecutionIdExercisesExerciseExecutionIdClientNoteMutationBody = BodyType<TrainWithMeModulesTrainingDtosRequestsPatchExerciseClientNoteRequest> | undefined
    export type PutWorkoutExecutionIdExercisesExerciseExecutionIdClientNoteMutationError = ErrorType<unknown>

    export const usePutWorkoutExecutionIdExercisesExerciseExecutionIdClientNote = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putWorkoutExecutionIdExercisesExerciseExecutionIdClientNote>>, TError,{id: number;exerciseExecutionId: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPatchExerciseClientNoteRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putWorkoutExecutionIdExercisesExerciseExecutionIdClientNote>>,
        TError,
        {id: number;exerciseExecutionId: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPatchExerciseClientNoteRequest>},
        TContext
      > => {
      return useMutation(getPutWorkoutExecutionIdExercisesExerciseExecutionIdClientNoteMutationOptions(options), queryClient);
    }
    export const putWorkoutExecutionIdExercisesExerciseExecutionIdTrainerNote = (
    id: number,
    exerciseExecutionId: number,
    trainWithMeModulesTrainingDtosRequestsPatchExerciseTrainerNoteRequest?: BodyType<TrainWithMeModulesTrainingDtosRequestsPatchExerciseTrainerNoteRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesExerciseTrainerNoteResponse>(
      {url: `/workout-execution/${id}/exercises/${exerciseExecutionId}/trainer-note`, method: 'PUT',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesTrainingDtosRequestsPatchExerciseTrainerNoteRequest, signal
    },
      options);
    }




export const getPutWorkoutExecutionIdExercisesExerciseExecutionIdTrainerNoteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putWorkoutExecutionIdExercisesExerciseExecutionIdTrainerNote>>, TError,{id: number;exerciseExecutionId: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPatchExerciseTrainerNoteRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putWorkoutExecutionIdExercisesExerciseExecutionIdTrainerNote>>, TError,{id: number;exerciseExecutionId: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPatchExerciseTrainerNoteRequest>}, TContext> => {

const mutationKey = ['putWorkoutExecutionIdExercisesExerciseExecutionIdTrainerNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putWorkoutExecutionIdExercisesExerciseExecutionIdTrainerNote>>, {id: number;exerciseExecutionId: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPatchExerciseTrainerNoteRequest>}> = (props) => {
          const {id,exerciseExecutionId,data} = props ?? {};

          return  putWorkoutExecutionIdExercisesExerciseExecutionIdTrainerNote(id,exerciseExecutionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutWorkoutExecutionIdExercisesExerciseExecutionIdTrainerNoteMutationResult = NonNullable<Awaited<ReturnType<typeof putWorkoutExecutionIdExercisesExerciseExecutionIdTrainerNote>>>
    export type PutWorkoutExecutionIdExercisesExerciseExecutionIdTrainerNoteMutationBody = BodyType<TrainWithMeModulesTrainingDtosRequestsPatchExerciseTrainerNoteRequest> | undefined
    export type PutWorkoutExecutionIdExercisesExerciseExecutionIdTrainerNoteMutationError = ErrorType<unknown>

    export const usePutWorkoutExecutionIdExercisesExerciseExecutionIdTrainerNote = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putWorkoutExecutionIdExercisesExerciseExecutionIdTrainerNote>>, TError,{id: number;exerciseExecutionId: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPatchExerciseTrainerNoteRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putWorkoutExecutionIdExercisesExerciseExecutionIdTrainerNote>>,
        TError,
        {id: number;exerciseExecutionId: number;data?: BodyType<TrainWithMeModulesTrainingDtosRequestsPatchExerciseTrainerNoteRequest>},
        TContext
      > => {
      return useMutation(getPutWorkoutExecutionIdExercisesExerciseExecutionIdTrainerNoteMutationOptions(options), queryClient);
    }
    export const postWorkoutExecutionIdStart = (
    id: number,
    params?: PostWorkoutExecutionIdStartParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesTrainingDtosResponsesWorkoutExecutionFullResponse>(
      {url: `/workout-execution/${id}/start`, method: 'POST',
        params, signal
    },
      options);
    }




export const getPostWorkoutExecutionIdStartMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWorkoutExecutionIdStart>>, TError,{id: number;params?: PostWorkoutExecutionIdStartParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postWorkoutExecutionIdStart>>, TError,{id: number;params?: PostWorkoutExecutionIdStartParams}, TContext> => {

const mutationKey = ['postWorkoutExecutionIdStart'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postWorkoutExecutionIdStart>>, {id: number;params?: PostWorkoutExecutionIdStartParams}> = (props) => {
          const {id,params} = props ?? {};

          return  postWorkoutExecutionIdStart(id,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostWorkoutExecutionIdStartMutationResult = NonNullable<Awaited<ReturnType<typeof postWorkoutExecutionIdStart>>>

    export type PostWorkoutExecutionIdStartMutationError = ErrorType<unknown>

    export const usePostWorkoutExecutionIdStart = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWorkoutExecutionIdStart>>, TError,{id: number;params?: PostWorkoutExecutionIdStartParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postWorkoutExecutionIdStart>>,
        TError,
        {id: number;params?: PostWorkoutExecutionIdStartParams},
        TContext
      > => {
      return useMutation(getPostWorkoutExecutionIdStartMutationOptions(options), queryClient);
    }
